const STORAGE_KEY = 'edvello-motion';

export const motionState = $state({ paused: false, reduced: false });

export function loadMotionPreference() {
  try {
    motionState.paused = localStorage.getItem(STORAGE_KEY) === 'paused';
  } catch {
    motionState.paused = false;
  }
}

export function toggleMotion() {
  motionState.paused = !motionState.paused;
  try {
    if (motionState.paused) localStorage.setItem(STORAGE_KEY, 'paused');
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    return;
  }
}

export function isMotionAllowed() {
  return !motionState.paused && !motionState.reduced;
}
